import React, { useEffect } from 'react';

import { makeStyles } from '@mui/styles';

import HeaderPublic from '../../components/HeaderPublic';

const Contacts = (props) => {
  const classes = useStyles();

  useEffect(() => {
    document.title = `RockerBox - ${props.title}`;
  });

  return (
    <>
      <HeaderPublic />
      <div className={classes.wrapperBody}>Contacts</div>
    </>
  );
};

export default Contacts;

const useStyles = makeStyles((theme) => ({
  wrapperBody: {
    marginTop: '100px',
  },
}));
